// extracted by mini-css-extract-plugin
module.exports = {"Root":"Questions_Root__SaYD1","WhiteBackground":"Questions_WhiteBackground__dFJ2T"};